<ng-container *ngFor="let img of images; let i = index">
  <img [src]="img" [ngClass]="{ active: activeIndex === i }" />
</ng-container>
